import React from 'react';
import ReactDOM from 'react-dom';
import Thickbox from '../components/modals/thickbox';
import {I18N, CONFIG} from '../globals/config';

import AssignmentSearchModal from '../components/modals/assignment-search-modal';
import JoinModal from '../components/modals/join-modal';

export default class ThickboxLoader {
	constructor(){
		let body = $( 'body' );
		body.append( '<div id="thickbox-place-holder"></div>' );
		$( '#load-assignment' ).on( 'click', ThickboxLoader._open_assignment_search_modal );
		body.on( 'click', '.' + CONFIG.join_modal_trigger_class + ', ' + '.' + CONFIG.join_modal_login_trigger_class, ThickboxLoader._open_join_modal );
	}

	static _open_join_modal( event ){
		event.preventDefault();
		var el      = $( this );
		let $open_with_login = el.hasClass( CONFIG.join_modal_login_trigger_class );
		let $subscription = _.isUndefined( el.data( 'id' ) ) ? 0 : el.data();

		ReactDOM.render(
			<Thickbox width="400" height="540" title={I18N.join_now} key={Date.now() + 'join-modal-thickbox'}>
				<JoinModal open_with_login={$open_with_login} subscription={$subscription}/>
			</Thickbox>, document.getElementById( "thickbox-place-holder" ) );

	}

	static _open_assignment_search_modal(){
		//using a key on a thickbox so we an close and re-open a new one
		//if we want to open the same we would have to do something with state 
		ReactDOM.render(
			<Thickbox width="600" height="540" title={I18N.load_assignment} key={Date.now() + 'assignment-search-thickbox'}>
				<AssignmentSearchModal/>
			</Thickbox>, document.getElementById( "thickbox-place-holder" ) );
	}
}


// WEBPACK FOOTER //
// ./src/util/thickbox-loader.js